import React from "react";

export const FormInput = ({
  label,
  type = "text",
  placeholder,
  icon,
  value,
  onChange,
  name,
}) => {
  return (
    <div className="flex flex-col w-full gap-2 mt-4 md:mt-2 lg:mt-0">
      <label className="text-[#FFFFFF] mb-1 text-[16px] lg:text-[20px]">
        {label}
      </label>
      <div className="flex items-center bg-[#282828] rounded-full px-6 py-4 gap-2">
        <img src={icon} alt="icon" className="w-6 h-6" />
        <input
          type={type}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className="no-autofill-bg bg-[#282828] border-none outline-none text-[#FFFFFF] w-full placeholder-[#949494] text-[14px] lg:text-[18px] font-lufga "
        />
      </div>
    </div>
  );
};
